import React, { useContext, useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Container, Box, Button } from '@mui/material';
import {  useNavigate } from 'react-router';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthContext } from '../Auth/Auth';

const Layout = ({ children }) => {

  const { currentUser, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    const success = await logout();
    if (success) {
      navigate('/login');
    }
  };


 
  return (
    <>
      <AppBar position="static" color="primary" elevation={1}>
        <Toolbar>
          <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
            {/* Replace with your actual logo */}
            <img 
              src="/logo512.png" 
              alt="Company Logo" 
              style={{ height: 40, marginRight: 16 }}
              onError={(e) => {e.target.style.display = 'none'}}
            />
            <Typography variant="h6" component="h1">
              Sweco Applications
            </Typography>
          </Box>
          
          <Button 
            color="inherit" 
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="xl" component="main" sx={{ py: 4 }}>
        {children}
      </Container>
      
      <Box 
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: theme => theme.palette.grey[100],
          borderTop: '1px solid',
          borderColor: theme => theme.palette.grey[300],
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Sweco  All rights reserved.
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default Layout;
